import React from 'react'
import { AttachmentDataWithRequiredAttachment } from '../../../../../../../../../../@types/types'
import { ImageCounterBadgeIndicator } from './ImageCounterBadgeIndicator'
import { TitleIndicator } from './TitleIndicator'
import styles from './CarouselIndicators.module.css'

interface CarouselIndicatorsProps {
  currentSlide: number
  totalPictures: number
  currentAttachment: AttachmentDataWithRequiredAttachment
}

export const CarouselIndicators: React.FC<CarouselIndicatorsProps> = ({
  currentSlide,
  totalPictures,
  currentAttachment,
}) => {
  return (
    <div className={styles.indicatorsContainer}>
      <ImageCounterBadgeIndicator currentIndex={currentSlide} totalPictures={totalPictures} />
      <TitleIndicator attachment={currentAttachment} />
    </div>
  )
}
